import { render, staticRenderFns } from "./ShikishaBetBet.vue?vue&type=template&id=1432bacd"
import script from "./ShikishaBetBet.vue?vue&type=script&lang=js"
export * from "./ShikishaBetBet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports